import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import "react-datepicker/dist/react-datepicker.css";
import { Link, useNavigate } from 'react-router-dom';
import { DataTableCustomStyles } from '../../../../../helper/dataTable.config';
import { Employee, Schools, UserAppsPermission, PreSignupEmployee, PreSignupEmployeeApps, Apps } from '../../../../../models'
import { DataStore, Predicates, SortDirection } from '@aws-amplify/datastore';
import * as alertify from 'alertifyjs';
import 'alertifyjs/build/css/alertify.css';
import { toast } from "react-toastify";
import { validateFileExtension } from "../../../../../helper/commonfunctions";
import capitalizeFirst from '../../../../../components/common/capitalizeFirst';
import capitalizeFirstChar from '../../../../../components/common/capitalizeFirstChar';
import EditButton from '../../../../../components/buttons/EditButton';
import DeleteButton from '../../../../../components/buttons/DeleteButton';
import { ValidateAdminRole } from '../../../../../helper/validateRole';
import { Avatar } from "@mui/material";
import { Auth } from 'aws-amplify';
import Layout from '../../../../../components/common/nav/admin/nav.component';
import AWS from "aws-sdk"
import Login from '../../../../../setup/auth/login.component';
import { Dialog } from "primereact/dialog";
import { Image } from "primereact/image";
import sidebar from "../../../../../assets/images/sidebarright.svg"
import { ExcelRenderer } from 'react-excel-renderer';
import { GetAWSObjectURL } from "../../../../../helper/aws";
import { Checkbox } from "primereact/checkbox";
import { API, graphqlOperation } from 'aws-amplify';
import * as queries from '../../../../../graphql/queries';
import * as mutations from '../../../../../graphql/mutations';
import awsmobile from "../../../../../aws-exports";

export default function EmployeeList() {

    const [fileObj, setFileObj] = useState("");
    const [allEmployees, setAllEmployees] = useState("");
    const [allSchools, setAllSchools] = useState("");
    const [visibleImport, setVisibleImport] = useState(false);
    const [visibleImportLogin, setVisibleImportLogin] = useState(false);
    const [importFileObj, setImportFileObj] = useState("");
    const [importLoginFileObj, setImportLoginFileObj] = useState("");
    const [allPreSignupEmployees, setAllPreSignupEmployees] = useState([]);
    const [checked, setChecked] = useState(true);
    const [preSignupChecked, setPreSignupChecked] = useState(false);

    //SET AWS Configuration
    AWS.config.update({
        accessKeyId: process.env.REACT_APP_AWS_AccessKeyId,
        secretAccessKey: process.env.REACT_APP_AWS_SecretAccessKey,
        region: process.env.REACT_APP_AWS_Region,
    });

    let navigateTo = useNavigate();

    //*Employees Table Columns Name
    const parentDataTableColumns = [
        {
            name: 'Employees',
            // selector: row =>  row.employee_name ,
            // console.log("row",row),

            // !== "" ? row.employee_name : `${row.firstName} ${row.lastName}`,

            selector: row => row.employee_name !== "" ? row.employee_name : `${row.lastName} , ${row.firstName}`,
            // cell: (row) => (
            //     <>
            //         <div className="flex gap-4 items-center">
            //             <Avatar alt="Remy Sharp" src={row.profilePic} />
            //             {row.name}
            //         </div>
            //     </>
            // ),
            width: "200px",
        },
        {
            name: "Employee Code",
            selector: row => row.employee_code,
            sortable: true,
        },
        {
            name: "School",
            selector: row => row.schoolName,
            sortable: true,
        },
        {
            name: 'Email',
            selector: row => row.email,
            sortable: true,
        },
        {
            name: 'City',
            selector: row => row.city,
            sortable: true,
        },
        {
            name: 'Action',
            cell: (row) => (
                <>
                    <div className="flex gap-8">
                        <Link onClick={(e) => handleEditClick(e, row['id'])} ><EditButton /></Link>
                        <Link onClick={(e) => handleDeleteClick(e, row['id'])} ><DeleteButton /></Link>
                    </div>
                </>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            center: true,
            button: true,
        }
    ];

    //Validate admin Logged In
    const [isAuthenticated, userHasAuthenticated] = useState(true);

    //State
    const [employeeList, SetEmployeeList] = useState([]);
    const [filterEmployeeList, SetFilterEmployeeList] = useState([]);

    //Edit Parent
    const handleEditClick = (e, id) => {
        e.preventDefault();
        navigateTo('/admin/setting/masters/createemployee/' + id) ;
    };



    async function changeFileSelected(e) {
        let fileObjData = e.target.files[0];

        let file_field = fileObjData.name;
        let allowedExtensions = ['csv'];
        let flag = false;
        flag = validateFileExtension(file_field, allowedExtensions);

        if (flag) {
            e.target.value = null;
            alert('Please select valid file format. Only ' + allowedExtensions.join(', ') + ' are allowed.'); return;
        } else {
            setFileObj(e.target.files[0])
        }
    }

    async function changeChecked(e, val) {
        if (val === 'Employee') {
            setPreSignupChecked(false)
            setChecked(true);
        } else {
            setPreSignupChecked(true)
            setChecked(false)
        }
    }

    async function changeImportFile(e) {
        let fileObjData = e.target.files[0];

        let file_field = fileObjData.name;
        let allowedExtensions = ['csv'];
        let flag = false;
        flag = validateFileExtension(file_field, allowedExtensions);

        if (flag) {
            e.target.value = null;
            alert('Please select valid file format. Only ' + allowedExtensions.join(', ') + ' are allowed.'); return;
        } else {
            setImportFileObj(e.target.files[0])
        }
    }

    async function changeImportLoginFile(e) {
        let fileObjData = e.target.files[0];

        let file_field = fileObjData.name;
        let allowedExtensions = ['csv'];
        let flag = false;
        flag = validateFileExtension(file_field, allowedExtensions);

        if (flag) {
            e.target.value = null;
            alert('Please select valid file format. Only ' + allowedExtensions.join(', ') + ' are allowed.'); return;
        } else {
            setImportLoginFileObj(e.target.files[0])
        }
    }
    //Delete Employees
    const handleDeleteClick = async (e, id) => {
        e.preventDefault();
        const objDeleteEmployee = await DataStore.query(Employee, id);
        alertify.confirm('Confirmation', 'Do you want to delete this record?', function () {
            //Delete Employees
            DataStore.delete(objDeleteEmployee);
            toast.error("Deleted");
            BindList();
        }
            , function () { });
    };

    //Get Employees List
    async function BindList() {

        try {

            ///Pratap Code
            // var employeeResponses = await DataStore.query(Employee, Predicates.ALL, {
            //     sort: s => s.employee_name(SortDirection.ASCENDING)
            // });

            let employeeResponses = [];
            let nextToken4 = null;
            let hasMoreData = true;
            while (hasMoreData) {
                const result2 = await API.graphql(graphqlOperation(queries.listEmployees, { limit: 10000, nextToken: nextToken4 }));
                const { items, nextToken: newNextToken } = result2.data.listEmployees;

                employeeResponses = [...employeeResponses, ...items];
                nextToken4 = newNextToken;
                hasMoreData = nextToken4 !== null && nextToken4 !== undefined ? nextToken4 : false;
            }
            employeeResponses = employeeResponses.filter(item => item._deleted !== true);
            // employeeResponses = employeeResponses.sort((a, b) => a.employee_name.localeCompare(b.employee_name));

            var getAllSchools = await DataStore.query(Schools, Predicates.ALL);

            setAllEmployees(employeeResponses)
            setAllSchools(getAllSchools)

            if (employeeResponses.length > 0) {
                var newResponse = [];
                for (var i = 0; i < employeeResponses.length; i++) {

                    let schoolName;
                    if (employeeResponses[i].school_id !== undefined) {
                        var schoolResponses = await DataStore.query(Schools, (c) => c.id.eq(employeeResponses[i].school_id));
                        if (schoolResponses.length > 0) { schoolName = schoolResponses[0].name } else { schoolName = "-" }
                    } else { schoolName = "-" }

                    let data = {
                        "id": employeeResponses[i].id,
                        "employee_name": employeeResponses[i].employee_name === undefined || employeeResponses[i].employee_name === null ? "" : employeeResponses[i].employee_name,
                        "firstName": employeeResponses[i].firstName === undefined || employeeResponses[i].firstName === null ? "" : employeeResponses[i].firstName,
                        "lastName": employeeResponses[i].lastName === undefined || employeeResponses[i].lastName === null ? "" : employeeResponses[i].lastName,
                        "employee_code": employeeResponses[i].employee_code,
                        "school_id": employeeResponses[i].school_id,
                        "address_1": employeeResponses[i].address_1,
                        "address_2": employeeResponses[i].address_2,
                        "city": employeeResponses[i].city,
                        "zip_code": employeeResponses[i].zip_code,
                        "country": employeeResponses[i].country,
                        "phone_no": employeeResponses[i].phone_no,
                        "email": employeeResponses[i].email,
                        "state": employeeResponses[i].state,
                        "schoolName": schoolName, "createdAt": employeeResponses[i].createdAt, "updatedAt": employeeResponses[i].updatedAt,
                    }
                    newResponse.push(data)
                }
                SetEmployeeList(newResponse);
                SetFilterEmployeeList(newResponse);
            } else {
                SetEmployeeList([]);
                SetFilterEmployeeList([]);
            }


            var preSignupEmployeeResponses = await DataStore.query(PreSignupEmployee, Predicates.ALL, {
                sort: s => s.employeeName(SortDirection.ASCENDING)
            });

            if (preSignupEmployeeResponses.length > 0) {
                var newResponse = [];
                for (var i = 0; i < preSignupEmployeeResponses.length; i++) {

                    let schoolName;
                    if (preSignupEmployeeResponses[i].school_id !== undefined) {
                        var schoolResponses = await DataStore.query(Schools, (c) => c.id.eq(preSignupEmployeeResponses[i].schoolCode));
                        if (schoolResponses.length > 0) { schoolName = schoolResponses[0].name } else { schoolName = "-" }
                    } else { schoolName = "-" }

                    let data = {
                        "id": preSignupEmployeeResponses[i].id,
                        "email": preSignupEmployeeResponses[i].email === undefined || preSignupEmployeeResponses[i].email === null ? "" : preSignupEmployeeResponses[i].email,
                        "role": preSignupEmployeeResponses[i].role,
                        "reportingMangerEmail": preSignupEmployeeResponses[i].reportingMangerEmail,
                        "employeeCode": preSignupEmployeeResponses[i].employeeCode,
                        "employeeName": preSignupEmployeeResponses[i].employeeName,
                        "schoolCode": preSignupEmployeeResponses[i].schoolCode,
                        "userType": preSignupEmployeeResponses[i].userType,
                        "isSixPeriodSAdmin": preSignupEmployeeResponses[i].isSixPeriodSAdmin,
                        "sixPeriodIsInitiator": preSignupEmployeeResponses[i].sixPeriodIsInitiator,
                        "sixPeriodIsApprover": preSignupEmployeeResponses[i].sixPeriodIsApprover,
                        "sixPeriodIsPayroll": preSignupEmployeeResponses[i].sixPeriodIsPayroll,
                        "certiSubRIsInitiator": preSignupEmployeeResponses[i].certiSubRIsInitiator,
                        "createdAt": preSignupEmployeeResponses[i].createdAt, "updatedAt": preSignupEmployeeResponses[i].updatedAt,
                        "certiSubReIsApprover": preSignupEmployeeResponses[i].certiSubReIsApprover,
                        "certiSubReqIsPayroll": preSignupEmployeeResponses[i].certiSubReqIsPayroll,
                        "designation": preSignupEmployeeResponses[i].designation,
                        "isUser": preSignupEmployeeResponses[i].isUser

                    }
                    newResponse.push(data)
                }
                setAllPreSignupEmployees(newResponse);
            } else {
                setAllPreSignupEmployees([]);
            }
        }
        catch (error) {
            console.log(error);
        }
    }

    const updateUserSUB = async (cognitoId, employeeId,role) => {

        console.log("updating cognito userID in our db")
        console.log("cognitoId", cognitoId)
        console.log("employeeId", employeeId)
        var employeeDetails = []
        if (employeeId) {
            employeeDetails = await API.graphql({ query: queries.getEmployee, variables: { id: employeeId } });
            employeeDetails = employeeDetails.data ? employeeDetails.data.getEmployee : []
        }

        console.log("employeeDetails", employeeDetails)
        if (employeeDetails) {
            var updatedUser = await API.graphql({
                query: mutations.updateEmployee,
                variables: {
                    input: {
                        id: employeeId,
                        _version: employeeDetails._version,
                        user_Id: cognitoId,
                        role:role
                    }
                }
            });
            console.log("updatedUser", updatedUser)
        }
    }
    const findCognitoUserByEmail = async (email) => {
        try {
            const cognito = new AWS.CognitoIdentityServiceProvider();

            var params =
            {
                UserPoolId: awsmobile.aws_user_pools_id,
                Limit: 60,
                "Filter": "email ^= \"" + email + "\""
            };

            await cognito.listUsers(params, (err, data) => {
                if (err) {
                    // return '';
                    //(err.message);
                } else {
                    var sub = "";
                    data.Users.forEach((user, i) => {
                        sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;
                        console.log("sub", sub)
                        return sub;
                    })
                }
                // if (!data.Users.length) {
                //     return '';
                // }
            });

        } catch (e) {
            //toast.error(e.message);
        }
    }

    async function previewEmployee() {

        // Import code needs to optimize
        const appIdData = Apps;

        if (fileObj === '') {
            toast.error('Please select file.');
            return;
        }

        if (fileObj.size === 0) {
            toast.error('Do not select empty file.');
        } else {
            ExcelRenderer(fileObj, async (err, resp) => {
                if (err) {
                    console.log(err);
                }
                else {

                    var parameterData = resp.rows
                    var newParameterArray = parameterData.slice(1);
                    let employeeListData = [...allEmployees]

                    for (let i = 0; i < newParameterArray.length; i++) {
                        var csvSchoolCode = newParameterArray[i][0];
                        var csvFirstName = newParameterArray[i][1];
                        var csvLastName = newParameterArray[i][2];
                        var csvEmployeeId = newParameterArray[i][3];
                        var csvReportingManagerEmail = newParameterArray[i][4];
                        var csvPhoneNumber = newParameterArray[i][5];
                        var csvEmail = newParameterArray[i][6];
                        var csvUserType = newParameterArray[i][7];
                        var csvAddress1 = newParameterArray[i][8];
                        var csvAddress2 = newParameterArray[i][9];
                        var csvCity = newParameterArray[i][10];
                        var csvZipCode = newParameterArray[i][11];
                        var csvCountry = newParameterArray[i][12];
                        var csvState = newParameterArray[i][13];

                        // New fields for only cognito
                        var csvRole = newParameterArray[i][14];
                        var isSixPeriodSAdmin = newParameterArray[i][15];
                        var sixPeriodIsInitiator = newParameterArray[i][16];
                        var sixPeriodIsApprover = newParameterArray[i][17];
                        var sixPeriodIsPayroll = newParameterArray[i][18];
                        /* var ispersonnelIsAdmin = newParameterArray[i][14];
                        var personnelIsInitiator = newParameterArray[i][15];
                        var personnelIsApprover = newParameterArray[i][16];
                        var personnelIsPayroll = newParameterArray[i][17]; */
                        var certiSubRIsInitiator = newParameterArray[i][19];
                        var certiSubReIsApprover = newParameterArray[i][20];
                        var certiSubReqIsPayroll = newParameterArray[i][21];

                        // New fields for amplify database
                        var WEEKLY_ABSENCE_REPORT = newParameterArray[i][22];
                        var WEEKLY_ABSENCE_REPORT_ADMIN = newParameterArray[i][23];
                        var TIME_REPORT = newParameterArray[i][24];
                        var SIX_PERIOD = newParameterArray[i][25];
                        var CLASSIFIED_SUB_REQUEST = newParameterArray[i][26];
                        var SUBSTITUTE_REQUEST_CERTIFICATED = newParameterArray[i][27];
                        var STIPENDS_FORM = newParameterArray[i][28];
                        var PERSONAL_SERVICE_AGREEMENT = newParameterArray[i][29];
                        var EMPLOYEE_HAND_BOOK = newParameterArray[i][30];
                        var PERSONNEL_ACTION_FORM = newParameterArray[i][31];

                        // Last two fields
                        var userPermission = newParameterArray[i][32];
                        var csvDesignation = newParameterArray[i][33];
                        var timeRIsInitiator = newParameterArray[i][34];
                        var timeRIsApprover = newParameterArray[i][35];
                        var timeRIsPayroll = newParameterArray[i][36];
                        var timeRIsSuperadmin = newParameterArray[i][37];

                        // var L1_authoritys = newParameterArray[i][37];
                        // var L2_authoritys = newParameterArray[i][38];

                        //For Stipend data saved in userAdditionalSettings table
                        var stipendInitiator = newParameterArray[i][38];
                        var stipendApprover = newParameterArray[i][39];
                        var stipendPayroll = newParameterArray[i][40];

                        var subReqClassifiedInitiator = newParameterArray[i][41];
                        var subReqClassifiedApprover = newParameterArray[i][42];
                        var subReqClassifiedPayroll = newParameterArray[i][43];
                        var personnelServiceAgreeInitiator = newParameterArray[i][44];
                        var personnelServiceAgreeApprover = newParameterArray[i][45];
                        var personnelServiceAgreePayroll = newParameterArray[i][46];

                        // COGNITO ONLY
                        var personnelIsApprover = newParameterArray[i][47];
                        var personnelIsInitiator = newParameterArray[i][48];
                        var personnelIsPayroll = newParameterArray[i][49];
                        var ispersonnelIsAdmin = newParameterArray[i][50];
                        let strike = 0;

                        let existingEmployee = employeeListData.filter(item => item.email === csvEmail);
                        let managerDetails = employeeListData.find(o => o.email === csvReportingManagerEmail);
                        let schoolDetails = allSchools.find(o => o.name.toUpperCase() === csvSchoolCode.toUpperCase());

                        var csvEmployeeName = capitalizeFirstChar(csvLastName) + ', ' + csvFirstName.toUpperCase();

                        if (!csvEmployeeName || !csvEmployeeId || !csvEmail || existingEmployee.length > 0) {
                            strike = 1;
                            if (existingEmployee.length > 0) { 
                                strike = 2;
                            }
                            console.log("strike", csvEmail)
                        }

                        if (existingEmployee.length > 0 && userPermission === 1) {

                            console.log(`${existingEmployee[0].user_Id} found in our database`)

                            const cognito = new AWS.CognitoIdentityServiceProvider();

                            if (existingEmployee[0].user_Id) {
                                console.log(`${existingEmployee[0].user_Id} cognito ID in our database`)
                                const params = {
                                    UserPoolId: awsmobile.aws_user_pools_id,
                                    Username: existingEmployee[0].user_Id,
                                    UserAttributes: [
                                        {
                                            Name: "name",
                                            Value: (csvEmployeeName) ? csvEmployeeName : '',
                                        },
                                        {
                                            Name: "custom:firstName",
                                            Value: (csvFirstName) ? csvFirstName.toUpperCase() : '',
                                        },
                                        {
                                            Name: "custom:lastName",
                                            Value: (csvLastName) ? capitalizeFirstChar(csvLastName) : '',
                                        },
                                        {
                                            Name: "custom:personnelIsApprover",
                                            Value: (personnelIsApprover) ? personnelIsApprover.toString() : '0',
                                        },
                                        {
                                            Name: "custom:personnelIsInitiator",
                                            Value: (personnelIsInitiator) ? personnelIsInitiator.toString() : '0',
                                        },
                                        {
                                            Name: "custom:personnelIsPayroll",
                                            Value: (personnelIsPayroll) ? personnelIsPayroll.toString() : '0',
                                        },
                                        {
                                            Name: "custom:ispersonnelIsAdmin",
                                            Value: (ispersonnelIsAdmin) ? ispersonnelIsAdmin.toString() : '0',
                                        },
                                        {
                                            Name: "custom:role",
                                            Value: (csvRole) ? csvRole : '',
                                        },
                                        {
                                            Name: "custom:city",
                                            Value: csvCity,
                                        },
                                        {
                                            Name: "custom:mobileNumber",
                                            Value: csvPhoneNumber.toString(),
                                        },
                                        {
                                            Name: "custom:address",
                                            Value: csvAddress1,
                                        },
                                        {
                                            Name: "custom:userCode",
                                            Value: csvEmployeeId.toString(),
                                        },
                                        {
                                            Name: "custom:reportingManagerId",
                                            Value: managerDetails ? managerDetails.user_Id : '',
                                        },
                                        {
                                            Name: "custom:isSixPeriodSAdmin",
                                            Value: isSixPeriodSAdmin.toString(),
                                        },
                                        {
                                            Name: "custom:sixPeriodIsInitiator",
                                            Value: sixPeriodIsInitiator.toString(),
                                        },
                                        {
                                            Name: "custom:sixPeriodIsApprover",
                                            Value: sixPeriodIsApprover.toString(),
                                        },
                                        {
                                            Name: "custom:sixPeriodIsPayroll",
                                            Value: sixPeriodIsPayroll.toString(),
                                        },
                                        {
                                            Name: "custom:certiSubRIsInitiator",
                                            Value: certiSubRIsInitiator.toString(),
                                        },
                                        {
                                            Name: "custom:certiSubReIsApprover",
                                            Value: certiSubReIsApprover.toString(),
                                        },
                                        {
                                            Name: "custom:certiSubReqIsPayroll",
                                            Value: certiSubReqIsPayroll.toString(),
                                        },
                                        {
                                            Name: "custom:timeRIsInitiator",
                                            Value: timeRIsInitiator.toString() === '1' ? '1' : '0',
                                        },
                                        {
                                            Name: "custom:timeRIsApprover",
                                            Value: timeRIsApprover.toString() === '1' ? '1' : '0',
                                        },
                                        {
                                            Name: "custom:timeRIsPayroll",
                                            Value: timeRIsPayroll.toString() === '1' ? '1' : '0',
                                        },
                                        {
                                            Name: "custom:timeRIsSAdmin",
                                            Value: timeRIsSuperadmin.toString() === '1' ? '1' : '0',
                                        },
                                    ],
                                };
                                console.log('cognitoparams --->', params);
                                try {
                                    cognito.adminUpdateUserAttributes(params, function (err, data) {
                                        if (err)
                                            console.log("Errr rr", err, err.stack);
                                        else
                                            console.log('cognitoparamsdata', data);
                                    });

                                      // User Confirmation 
                                    //   const params2 = {
                                    //     UserPoolId: awsmobile.aws_user_pools_id,
                                    //     Username: csvEmail,
                                    //     Password: 'Gusd@2023',
                                    //     Permanent: true,
                                    // };


                                    // User Confirmation 
                                    // cognito.adminSetUserPassword(params2, (err, data) => {
                                    //     if (err) {
                                    //         console.log('Error confirming user:', err);
                                    //     } else {
                                    //         console.log('User confirmed successfully:', data);
                                    //     }
                                    // });

                                    console.log('User attribute updated successfully in cognito.');
                                } catch (error) {
                                    console.error('Error updating cognito user attribute:', error);
                                }
                            }
                            else {

                                console.log(`${existingEmployee[0].email} cognito ID is blank`)

                                // Find cognito user by email and get sub to update employee user_Id

                                try {
                                    const cognito = new AWS.CognitoIdentityServiceProvider();

                                    var params =
                                    {
                                        UserPoolId: awsmobile.aws_user_pools_id,
                                        Limit: 60,
                                        "Filter": "email ^= \"" + existingEmployee[0].email + "\""
                                    };

                                    let cognitoUserList = await cognito.listUsers(params, async (err, data) => {
                                        if (err) {
                                            // return '';
                                            //(err.message);
                                        } else {
                                            var sub = "";
                                            data.Users.forEach(async (user, i) => {
                                                sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;

                                                console.log(`cognito ID updating in our databse for user ${existingEmployee[0].email}`)
                                                await updateUserSUB(sub, existingEmployee[0].id,csvRole)

                                                // Update Cognito


                                                // "custom:firstName": csvFirstName,
                                                // "custom:lastName": csvLastName,
                                                // "custom:role": csvRole,
                                                // "name": csvEmployeeName,
                                                // "custom:city": csvCity,
                                                // "custom:mobileNumber": csvPhoneNumber.toString(),
                                                // "custom:address": csvAddress1,
                                                // "custom:userCode": csvEmployeeId.toString(),
                                                // "custom:reportingManagerId": managerDetails ? managerDetails.user_Id : '',
                                                // "custom:isSixPeriodSAdmin": isSixPeriodSAdmin.toString(),
                                                // "custom:sixPeriodIsInitiator": sixPeriodIsInitiator.toString(),
                                                // "custom:sixPeriodIsApprover": sixPeriodIsApprover.toString(),
                                                // "custom:sixPeriodIsPayroll": sixPeriodIsPayroll.toString(),
                                                // "custom:certiSubRIsInitiator": certiSubRIsInitiator.toString(),
                                                // "custom:certiSubReIsApprover": certiSubReIsApprover.toString(),
                                                // "custom:certiSubReqIsPayroll": certiSubReqIsPayroll.toString(),
                                                // "custom:timeRIsInitiator": timeRIsInitiator === '1' ? timeRIsInitiator : '0',
                                                // "custom:timeRIsApprover": timeRIsApprover === '1' ? timeRIsApprover : '0',
                                                // "custom:timeRIsPayroll": timeRIsPayroll === '1' ? timeRIsPayroll : '0',
                                                // "custom:timeRIsSAdmin": timeRIsSuperadmin === '1' ? timeRIsSuperadmin : '0',


                                                const params = {
                                                    UserPoolId: awsmobile.aws_user_pools_id,
                                                    Username: sub,
                                                    UserAttributes: [
                                                        {
                                                            Name: "name",
                                                            Value: (csvEmployeeName) ? csvEmployeeName : '',
                                                        },
                                                        {
                                                            Name: "custom:firstName",
                                                            Value: (csvFirstName) ? csvFirstName.toUpperCase() : '',
                                                        },
                                                        {
                                                            Name: "custom:lastName",
                                                            Value: (csvLastName) ? capitalizeFirstChar(csvLastName) : '',
                                                        },
                                                        {
                                                            Name: "custom:personnelIsApprover",
                                                            Value: (personnelIsApprover) ? personnelIsApprover.toString() : '0',
                                                        },
                                                        {
                                                            Name: "custom:personnelIsInitiator",
                                                            Value: (personnelIsInitiator) ? personnelIsInitiator.toString() : '0',
                                                        },
                                                        {
                                                            Name: "custom:personnelIsPayroll",
                                                            Value: (personnelIsPayroll) ? personnelIsPayroll.toString() : '0',
                                                        },
                                                        {
                                                            Name: "custom:ispersonnelIsAdmin",
                                                            Value: (ispersonnelIsAdmin) ? ispersonnelIsAdmin.toString() : '0',
                                                        },
                                                        {
                                                            Name: "custom:role",
                                                            Value: (csvRole) ? csvRole : '',
                                                        },
                                                        {
                                                            Name: "custom:city",
                                                            Value: csvCity,
                                                        },
                                                        {
                                                            Name: "custom:mobileNumber",
                                                            Value: csvPhoneNumber.toString(),
                                                        },
                                                        {
                                                            Name: "custom:address",
                                                            Value: csvAddress1,
                                                        },
                                                        {
                                                            Name: "custom:userCode",
                                                            Value: csvEmployeeId.toString(),
                                                        },
                                                        {
                                                            Name: "custom:reportingManagerId",
                                                            Value: managerDetails ? managerDetails.user_Id : '',
                                                        },
                                                        {
                                                            Name: "custom:isSixPeriodSAdmin",
                                                            Value: isSixPeriodSAdmin.toString(),
                                                        },
                                                        {
                                                            Name: "custom:sixPeriodIsInitiator",
                                                            Value: sixPeriodIsInitiator.toString(),
                                                        },
                                                        {
                                                            Name: "custom:sixPeriodIsApprover",
                                                            Value: sixPeriodIsApprover.toString(),
                                                        },
                                                        {
                                                            Name: "custom:sixPeriodIsPayroll",
                                                            Value: sixPeriodIsPayroll.toString(),
                                                        },
                                                        {
                                                            Name: "custom:certiSubRIsInitiator",
                                                            Value: certiSubRIsInitiator.toString(),
                                                        },
                                                        {
                                                            Name: "custom:certiSubReIsApprover",
                                                            Value: certiSubReIsApprover.toString(),
                                                        },
                                                        {
                                                            Name: "custom:certiSubReqIsPayroll",
                                                            Value: certiSubReqIsPayroll.toString(),
                                                        },
                                                        {
                                                            Name: "custom:timeRIsInitiator",
                                                            Value: timeRIsInitiator.toString() === '1' ? '1' : '0',
                                                        },
                                                        {
                                                            Name: "custom:timeRIsApprover",
                                                            Value: timeRIsApprover.toString() === '1' ? '1' : '0',
                                                        },
                                                        {
                                                            Name: "custom:timeRIsPayroll",
                                                            Value: timeRIsPayroll.toString() === '1' ? '1' : '0',
                                                        },
                                                        {
                                                            Name: "custom:timeRIsSAdmin",
                                                            Value: timeRIsSuperadmin.toString() === '1' ? '1' : '0',
                                                        },
                                                    ],
                                                };

                                                try {
                                                    cognito.adminUpdateUserAttributes(params, function (err, data) {
                                                        if (err)
                                                            console.log("Errr rr", err, err.stack);
                                                        else
                                                            console.log("User attribute", data);
                                                    });
                                                    console.log('User attribute updated successfully.');
                                                } catch (error) {
                                                    console.error('Error updating user attribute:', error);
                                                }
                                            })
                                        }

                                        console.log("data.Users.length", data.Users.length)
                                        if (!data.Users.length) {

                                            console.log(`creating cognito user ${csvEmail}`)
                                            // Create cognitouser
                                            let userCreated = await Auth.signUp({
                                                username: csvEmail,
                                                password: 'Gusd@2023',
                                                attributes: {
                                                    email: csvEmail,
                                                    name: csvEmployeeName,
                                                    "custom:firstName": csvFirstName.toUpperCase(),
                                                    "custom:lastName": capitalizeFirstChar(csvLastName),
                                                    "custom:role": csvRole,
                                                    "name": csvEmployeeName,
                                                    "custom:city": csvCity,
                                                    "custom:gender": '',
                                                    "custom:mobileNumber": csvPhoneNumber.toString(),
                                                    "custom:address": csvAddress1,
                                                    "custom:userCode": csvEmployeeId.toString(),
                                                    "custom:reportingManagerId": managerDetails ? managerDetails.user_Id : '',
                                                    "custom:isSixPeriodSAdmin": isSixPeriodSAdmin.toString(),
                                                    "custom:sixPeriodIsInitiator": sixPeriodIsInitiator.toString(),
                                                    "custom:sixPeriodIsApprover": sixPeriodIsApprover.toString(),
                                                    "custom:sixPeriodIsPayroll": sixPeriodIsPayroll.toString(),
                                                    "custom:certiSubRIsInitiator": certiSubRIsInitiator.toString(),
                                                    "custom:certiSubReIsApprover": certiSubReIsApprover.toString(),
                                                    "custom:certiSubReqIsPayroll": certiSubReqIsPayroll.toString(),
                                                    "custom:timeRIsInitiator": timeRIsInitiator.toString() === '1' ? '1' : '0',
                                                    "custom:timeRIsApprover": timeRIsApprover.toString() === '1' ? '1' : '0',
                                                    "custom:timeRIsPayroll": timeRIsPayroll.toString() === '1' ? '1' : '0',
                                                    "custom:timeRIsSAdmin": timeRIsSuperadmin.toString() === '1' ? '1' : '0',
                                                    "custom:ispersonnelIsAdmin": ispersonnelIsAdmin.toString(),
                                                    "custom:personnelIsInitiator": personnelIsInitiator.toString(),
                                                    "custom:personnelIsApprover": personnelIsApprover.toString(),
                                                    "custom:personnelIsPayroll": personnelIsPayroll.toString()
                                                },
                                                autoSignIn: {
                                                    // optional - enables auto sign in after user is confirmed
                                                    enabled: true,
                                                },
                                            });

                                            // Updating cognito id in Employee table
                                            var getEmployeeDetails = []
                                            if (existingEmployee[0].id) {
                                                getEmployeeDetails = await API.graphql({ query: queries.getEmployee, variables: { id: existingEmployee[0].id } });
                                                getEmployeeDetails = getEmployeeDetails.data ? getEmployeeDetails.data.getEmployee : []
                                            }

                                            console.log("updating user_ID in our databse for user ", existingEmployee[0].email)
                                            if (getEmployeeDetails) {
                                                await API.graphql({
                                                    query: mutations.updateEmployee,
                                                    variables: {
                                                        input: {
                                                            id: existingEmployee[0].id,
                                                            _version: getEmployeeDetails._version,
                                                            user_Id: userCreated.userSub,
                                                            role: userCreated.role,
                                                        }
                                                    }
                                                });
                                            }
                                        }
                                    });

                                    console.log("cognitoUserList", cognitoUserList)

                                } catch (e) {
                                    //toast.error(e.message);
                                }
                            }

                            var getEmployeeDetails = []
                            if (existingEmployee[0].id) {
                                getEmployeeDetails = await API.graphql({ query: queries.getEmployee, variables: { id: existingEmployee[0].id } });
                                getEmployeeDetails = getEmployeeDetails.data ? getEmployeeDetails.data.getEmployee : []
                            }
                            console.log("updating firstName, lastName of ", existingEmployee[0].email)
                            if (getEmployeeDetails) {
                                await API.graphql({
                                    query: mutations.updateEmployee,
                                    variables: {
                                        input: {
                                            id: existingEmployee[0].id,
                                            _version: getEmployeeDetails._version,
                                            employee_name: csvEmployeeName,
                                            firstName: csvFirstName.toUpperCase(),
                                            lastName: capitalizeFirstChar(csvLastName),
                                            role: csvRole,
                                        }
                                    }
                                });
                            }



                            await DataStore.delete(UserAppsPermission, (c) => c.UserId.eq(existingEmployee[0].user_Id)).then(async () => {
                                if (WEEKLY_ABSENCE_REPORT === 1) { await DataStore.save(new UserAppsPermission({ "AppId": appIdData.WEEKLY_ABSENCE_REPORT, "UserId": existingEmployee[0].user_Id })) }
                                if (WEEKLY_ABSENCE_REPORT_ADMIN === 1) { await DataStore.save(new UserAppsPermission({ "AppId": appIdData.WEEKLY_ABSENCE_REPORT_ADMIN, "UserId": existingEmployee[0].user_Id })) }
                                if (TIME_REPORT === 1) { await DataStore.save(new UserAppsPermission({ "AppId": appIdData.TIME_REPORT, "UserId": existingEmployee[0].user_Id })) }
                                if (SIX_PERIOD === 1) { await DataStore.save(new UserAppsPermission({ "AppId": appIdData.SIX_PERIOD, "UserId": existingEmployee[0].user_Id })) }
                                if (CLASSIFIED_SUB_REQUEST === 1) { await DataStore.save(new UserAppsPermission({ "AppId": appIdData.CLASSIFIED_SUB_REQUEST, "UserId": existingEmployee[0].user_Id })) }
                                if (SUBSTITUTE_REQUEST_CERTIFICATED === 1) { await DataStore.save(new UserAppsPermission({ "AppId": appIdData.SUBSTITUTE_REQUEST_CERTIFICATED, "UserId": existingEmployee[0].user_Id })) }
                                if (STIPENDS_FORM === 1) { await DataStore.save(new UserAppsPermission({ "AppId": appIdData.STIPENDS_FORM, "UserId": existingEmployee[0].user_Id })) }
                                if (PERSONAL_SERVICE_AGREEMENT === 1) { await DataStore.save(new UserAppsPermission({ "AppId": appIdData.PERSONAL_SERVICE_AGREEMENT, "UserId": existingEmployee[0].user_Id })) }
                                if (EMPLOYEE_HAND_BOOK === 1) { await DataStore.save(new UserAppsPermission({ "AppId": appIdData.EMPLOYEE_HAND_BOOK, "UserId": existingEmployee[0].user_Id })) }
                                if (PERSONNEL_ACTION_FORM === 1) { await DataStore.save(new UserAppsPermission({ "AppId": appIdData.PERSONNEL_ACTION_FORM, "UserId": existingEmployee[0].user_Id })) }
                            });

                            //Update user additional settings data
                            let response = [];
                            let listUserAdditionalSettingsData = await API.graphql(graphqlOperation(queries.listUserAdditionalSettings, {
                                filter: {
                                }, limit: 10000
                            }));

                            response = listUserAdditionalSettingsData.data.listUserAdditionalSettings.items.filter(item => item._deleted !== true);
                            response = listUserAdditionalSettingsData.data.listUserAdditionalSettings.items.filter(item => item.userId == existingEmployee[0].user_Id);

                            console.log("updating additional for ", existingEmployee[0].email)

                            if (response.length > 0) {
                                // Update record

                                const originalUpdated = await API.graphql({
                                    query: mutations.updateUserAdditionalSettings,
                                    variables: {
                                        input: {
                                            id: response[0].id,
                                            _version: response[0]._version,
                                            stipendApprover: stipendApprover.toString() === '1' ? '1' : '0',
                                            stipendInitiator: stipendInitiator.toString() === '1' ? '1' : '0',
                                            stipendPayroll: stipendPayroll.toString() === '1' ? '1' : '0',
                                            subReqClassifiedInitiator: subReqClassifiedInitiator.toString() === '1' ? '1' : '0',
                                            subReqClassifiedApprover: subReqClassifiedApprover.toString() === '1' ? '1' : '0',
                                            subReqClassifiedPayroll: subReqClassifiedPayroll.toString() === '1' ? '1' : '0',
                                            personnelServiceAgreeInitiator: personnelServiceAgreeInitiator.toString() === '1' ? '1' : '0',
                                            personnelServiceAgreeApprover: personnelServiceAgreeApprover.toString() === '1' ? '1' : '0',
                                            personnelServiceAgreePayroll: personnelServiceAgreePayroll.toString() === '1' ? '1' : '0'
                                        }
                                    }
                                });

                                console.log("updated additional settings ", originalUpdated)
                            }
                            else {
                                let saveUserAdditionalData = await API.graphql(
                                    graphqlOperation(mutations.createUserAdditionalSettings, {
                                        input: {
                                            stipendApprover: stipendApprover.toString() === '1' ? '1' : '0',
                                            stipendInitiator: stipendInitiator.toString() === '1' ? '1' : '0',
                                            stipendPayroll: stipendPayroll.toString() === '1' ? '1' : '0',
                                            subReqClassifiedInitiator: subReqClassifiedInitiator.toString() === '1' ? '1' : '0',
                                            subReqClassifiedApprover: subReqClassifiedApprover.toString() === '1' ? '1' : '0',
                                            subReqClassifiedPayroll: subReqClassifiedPayroll.toString() === '1' ? '1' : '0',
                                            personnelServiceAgreeInitiator: personnelServiceAgreeInitiator.toString() === '1' ? '1' : '0',
                                            personnelServiceAgreeApprover: personnelServiceAgreeApprover.toString() === '1' ? '1' : '0',
                                            personnelServiceAgreePayroll: personnelServiceAgreePayroll.toString() === '1' ? '1' : '0',
                                            userId: existingEmployee[0].user_Id
                                        }
                                    })
                                );
                            }
                        }

                        if (strike === 0) {
                            console.log('storing in our db', csvEmail);
                            await DataStore.save(
                                new Employee({
                                    "employee_name": csvEmployeeName,
                                    "firstName": csvFirstName.toUpperCase(),
                                    "lastName": capitalizeFirstChar(csvLastName),
                                    "phone_no": csvPhoneNumber.toString(),
                                    "email": csvEmail,
                                    "role":  csvRole,
                                    "address_1": csvAddress1,
                                    "address_2": csvAddress2,
                                    "city": csvCity,
                                    "zip_code": csvZipCode.toString(),
                                    "state": csvState,
                                    "country": csvCountry,
                                    "employee_code": csvEmployeeId.toString(),
                                    "school_id": schoolDetails ? schoolDetails.id : '',
                                    "employeeType": csvUserType,
                                    "designation": csvDesignation,
                                })
                            ).then(async (res) => {

                                let original = await DataStore.query(Employee, res.id);
                                allEmployees.push(original)
                                
                                // var fullEmpName = csvEmployeeName.split(' ');
                                // let firstName = fullEmpName[0] ? fullEmpName[0] : '';
                                // let lastName = fullEmpName[1] ? fullEmpName[1] : '';

                                /*  try {
                                     const cognito = new AWS.CognitoIdentityServiceProvider();
         
                                     var params =
                                     {
                                         UserPoolId: awsmobile.aws_user_pools_id,
                                         Limit: 100,
                                         "Filter": "email ^= \"" + L1_authoritys + "\""
                                     };
         
                                     await cognito.listUsers(params, (err, data) => {
                                         if (err) {
                                             //(err.message);
                                         } else {
                                             let usersData = []
                                             var sub = "";
                                             var email = "";
         
                                             data.Users.forEach((user, i) => {
                                                 sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;
                                                 email = user.Attributes.find(attr => attr.Name === "email")?.Value;
                                                 usersData.push(sub)
         
                                                 //usersData.push({ firstName: userFirstName, lastName: userLastName, label: userFirstName + " " + userLastName, value: adminUsers[i].Username });
                                             })
         
                                         }
                                     });
         
                                 } catch (e) {
                                     toast.error(e.message);
                                 } */


                                if (userPermission === 1) {
                                    try {
                                        console.log("creating cognito user ", csvEmail)
                                        let userCreated = await Auth.signUp({
                                            username: csvEmail,
                                            password: 'Gusd@2023',
                                            attributes: {
                                                email: csvEmail,
                                                name: csvEmployeeName,
                                                "custom:firstName": csvFirstName.toUpperCase(),
                                                "custom:lastName": capitalizeFirstChar(csvLastName),
                                                "custom:role": csvRole,
                                                "name": csvEmployeeName,
                                                "custom:city": csvCity,
                                                "custom:gender": '',
                                                "custom:mobileNumber": csvPhoneNumber.toString(),
                                                "custom:address": csvAddress1,
                                                "custom:userCode": csvEmployeeId.toString(),
                                                "custom:reportingManagerId": managerDetails ? managerDetails.user_Id : '',
                                                "custom:isSixPeriodSAdmin": isSixPeriodSAdmin.toString(),
                                                "custom:sixPeriodIsInitiator": sixPeriodIsInitiator.toString(),
                                                "custom:sixPeriodIsApprover": sixPeriodIsApprover.toString(),
                                                "custom:sixPeriodIsPayroll": sixPeriodIsPayroll.toString(),
                                                "custom:ispersonnelIsAdmin": ispersonnelIsAdmin.toString(),
                                                "custom:personnelIsInitiator": personnelIsInitiator.toString(),
                                                "custom:personnelIsApprover": personnelIsApprover.toString(),
                                                "custom:personnelIsPayroll": personnelIsPayroll.toString(),
                                                "custom:certiSubRIsInitiator": certiSubRIsInitiator.toString(),
                                                "custom:certiSubReIsApprover": certiSubReIsApprover.toString(),
                                                "custom:certiSubReqIsPayroll": certiSubReqIsPayroll.toString(),
                                                "custom:timeRIsInitiator": timeRIsInitiator.toString() === '1' ? '1' : '0',
                                                "custom:timeRIsApprover": timeRIsApprover.toString() === '1' ? '1' : '0',
                                                "custom:timeRIsPayroll": timeRIsPayroll.toString() === '1' ? '1' : '0',
                                                "custom:timeRIsSAdmin": timeRIsSuperadmin.toString() === '1' ? '1' : '0',
                                                // "custom:L1_authoritys": L1_authoritys ? L1_authoritys : '',
                                                // "custom:L2_authoritys": L2_authoritys ? L2_authoritys : '',

                                            },
                                            autoSignIn: {
                                                // optional - enables auto sign in after user is confirmed
                                                enabled: true,
                                            },
                                        });

                                        if (WEEKLY_ABSENCE_REPORT === 1) { await DataStore.save(new UserAppsPermission({ "AppId": appIdData.WEEKLY_ABSENCE_REPORT, "UserId": userCreated.userSub })) }
                                        if (WEEKLY_ABSENCE_REPORT_ADMIN === 1) { await DataStore.save(new UserAppsPermission({ "AppId": appIdData.WEEKLY_ABSENCE_REPORT_ADMIN, "UserId": userCreated.userSub })) }
                                        if (TIME_REPORT === 1) { await DataStore.save(new UserAppsPermission({ "AppId": appIdData.TIME_REPORT, "UserId": userCreated.userSub })) }
                                        if (SIX_PERIOD === 1) { await DataStore.save(new UserAppsPermission({ "AppId": appIdData.SIX_PERIOD, "UserId": userCreated.userSub })) }
                                        if (CLASSIFIED_SUB_REQUEST === 1) { await DataStore.save(new UserAppsPermission({ "AppId": appIdData.CLASSIFIED_SUB_REQUEST, "UserId": userCreated.userSub })) }
                                        if (SUBSTITUTE_REQUEST_CERTIFICATED === 1) { await DataStore.save(new UserAppsPermission({ "AppId": appIdData.SUBSTITUTE_REQUEST_CERTIFICATED, "UserId": userCreated.userSub })) }
                                        if (STIPENDS_FORM === 1) { await DataStore.save(new UserAppsPermission({ "AppId": appIdData.STIPENDS_FORM, "UserId": userCreated.userSub })) }
                                        if (PERSONAL_SERVICE_AGREEMENT === 1) { await DataStore.save(new UserAppsPermission({ "AppId": appIdData.PERSONAL_SERVICE_AGREEMENT, "UserId": userCreated.userSub })) }
                                        if (EMPLOYEE_HAND_BOOK === 1) { await DataStore.save(new UserAppsPermission({ "AppId": appIdData.EMPLOYEE_HAND_BOOK, "UserId": userCreated.userSub })) }
                                        if (PERSONNEL_ACTION_FORM === 1) { await DataStore.save(new UserAppsPermission({ "AppId": appIdData.PERSONNEL_ACTION_FORM, "UserId": userCreated.userSub })) }

                                        let original = await DataStore.query(Employee, res.id);
                                        var updatedUserDetails = await DataStore.save(
                                            Employee.copyOf(original, (updated) => {
                                                updated.user_Id = userCreated.userSub;
                                            })
                                        );
                                        employeeListData.push(updatedUserDetails)

                                        // Save user additional data
                                        let saveUserAdditionalData = await API.graphql(
                                            graphqlOperation(mutations.createUserAdditionalSettings, {
                                                input: {
                                                    stipendApprover: stipendApprover.toString() === '1' ? '1' : '0',
                                                    stipendInitiator: stipendInitiator.toString() === '1' ? '1' : '0',
                                                    stipendPayroll: stipendPayroll.toString() === '1' ? '1' : '0',
                                                    subReqClassifiedInitiator: subReqClassifiedInitiator.toString() === '1' ? '1' : '0',
                                                    subReqClassifiedApprover: subReqClassifiedApprover.toString() === '1' ? '1' : '0',
                                                    subReqClassifiedPayroll: subReqClassifiedPayroll.toString() === '1' ? '1' : '0',
                                                    personnelServiceAgreeInitiator: personnelServiceAgreeInitiator.toString() === '1' ? '1' : '0',
                                                    personnelServiceAgreeApprover: personnelServiceAgreeApprover.toString() === '1' ? '1' : '0',
                                                    personnelServiceAgreePayroll: personnelServiceAgreePayroll.toString() === '1' ? '1' : '0',
                                                    userId: userCreated.userSub
                                                }
                                            })
                                        );


                                        // User Confirmation 
                                        const params2 = {
                                            UserPoolId: awsmobile.aws_user_pools_id,
                                            Username: csvEmail,
                                            Password: 'Gusd@2023',
                                            Permanent: true,
                                        };
                                        
                                        const cognito = new AWS.CognitoIdentityServiceProvider();

                                        // User Confirmation 
                                        cognito.adminSetUserPassword(params2, (err, data) => {
                                            if (err) {
                                                console.log('Error confirming user:', err);
                                            } else {
                                                console.log('User confirmed successfully:', data);
                                            }
                                        });
                                    }
                                    catch (error) {
                                        console.log("cognito getting error", error)

                                        // Console.log("checking cognito user if found we will update")
                                        try {
                                            const cognito = new AWS.CognitoIdentityServiceProvider();

                                            var params =
                                            {
                                                UserPoolId: awsmobile.aws_user_pools_id,
                                                Limit: 60,
                                                "Filter": "email ^= \"" + res.email + "\""
                                            };

                                            let cognitoUserList = await cognito.listUsers(params, async (err, data) => {
                                                if (err) {
                                                    // return '';
                                                    //(err.message);
                                                } else {
                                                    var sub = "";
                                                    data.Users.forEach(async (user, i) => {
                                                        sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;

                                                        await updateUserSUB(sub, res.id,csvRole)

                                                        // Update Cognito

                                                        const params = {
                                                            UserPoolId: awsmobile.aws_user_pools_id,
                                                            Username: sub,
                                                            UserAttributes: [
                                                                {
                                                                    Name: "name",
                                                                    Value: (csvEmployeeName) ? csvEmployeeName : '',
                                                                },
                                                                {
                                                                    Name: "custom:firstName",
                                                                    Value: (csvFirstName) ? csvFirstName.toUpperCase() : '',
                                                                },
                                                                {
                                                                    Name: "custom:lastName",
                                                                    Value: (csvLastName) ? capitalizeFirstChar(csvLastName) : '',
                                                                },
                                                                {
                                                                    Name: "custom:personnelIsApprover",
                                                                    Value: (personnelIsApprover) ? personnelIsApprover.toString() : '0',
                                                                },
                                                                {
                                                                    Name: "custom:personnelIsInitiator",
                                                                    Value: (personnelIsInitiator) ? personnelIsInitiator.toString() : '0',
                                                                },
                                                                {
                                                                    Name: "custom:personnelIsPayroll",
                                                                    Value: (personnelIsPayroll) ? personnelIsPayroll.toString() : '0',
                                                                },
                                                                {
                                                                    Name: "custom:ispersonnelIsAdmin",
                                                                    Value: (ispersonnelIsAdmin) ? ispersonnelIsAdmin.toString() : '0',
                                                                },
                                                            ],
                                                        };

                                                        try {
                                                            cognito.adminUpdateUserAttributes(params, function (err, data) {
                                                                if (err)
                                                                    console.log("Errr rr", err, err.stack);
                                                                else
                                                                    console.log(data);
                                                            });
                                                            console.log('User attribute updated successfully.');
                                                        } catch (error) {
                                                            console.error('Error updating user attribute:', error);
                                                        }
                                                    })
                                                }
                                            });

                                            console.log("cognitoUserList", cognitoUserList)

                                        } catch (e) {
                                            //toast.error(e.message);
                                        }

                                        // End
                                    }
                                }

                            });
                        }
                    }

                }
            });
        }

        setFileObj("")
        setVisibleImport(false)
        toast.success("Imported Successfully");

    }

    async function downloadDocument(filePath) {
        let filePathURL = await GetAWSObjectURL(filePath);
        const link = document.createElement("a");
        link.href = filePathURL;
        link.download = "";
        document.body.appendChild(link);
        link.click();
        link.remove();
    }

    /* Save sign up data     
    ---14/08/2023--- ///Author: Asharani Navale 
    */
    async function saveSignupEmployee() {

        const appIdData = Apps;

        if (importFileObj === '') {
            toast.error('Please select file.');
            return;
        }

        if (importFileObj.size === 0) {
            toast.error('Do not select empty file.');
        } else {
            ExcelRenderer(importFileObj, async (err, resp) => {
                if (err) {
                    console.log(err);
                }
                else {
                    console.log('importFileObjresp --->', resp);
                    var parameterData = resp.rows
                    var newParameterArray = parameterData.slice(1);
                    let preSignupEmployeesListData = [...allPreSignupEmployees]

                    for (let i = 0; i < newParameterArray.length; i++) {
                        var csvSchoolCode = newParameterArray[i][0];
                        // var csvEmployeeName = newParameterArray[i][1];
                        var csvFirstName = newParameterArray[i][1];
                        var csvLastName = newParameterArray[i][2];
                        var csvEmployeeId = newParameterArray[i][3];
                        var csvReportingManagerEmail = newParameterArray[i][4];//4- No need to add
                        var csvEmail = newParameterArray[i][6];
                        var csvUserType = newParameterArray[i][7]; //7-12 No need to add
                        var csvRole = newParameterArray[i][14];
                        var isSixPeriodSAdmin = newParameterArray[i][15];
                        var sixPeriodIsInitiator = newParameterArray[i][16];
                        var sixPeriodIsApprover = newParameterArray[i][17];
                        var sixPeriodIsPayroll = newParameterArray[i][18];
                        /* var ispersonnelIsAdmin = newParameterArray[i][14];
                        var personnelIsInitiator = newParameterArray[i][15];
                        var personnelIsApprover = newParameterArray[i][16];
                        var personnelIsPayroll = newParameterArray[i][17]; */
                        var certiSubRIsInitiator = newParameterArray[i][19];
                        var certiSubReIsApprover = newParameterArray[i][20];
                        var certiSubReqIsPayroll = newParameterArray[i][21];


                        // New fields for amplify database
                        var WEEKLY_ABSENCE_REPORT = newParameterArray[i][22];
                        var WEEKLY_ABSENCE_REPORT_ADMIN = newParameterArray[i][23];
                        var TIME_REPORT = newParameterArray[i][24];
                        var SIX_PERIOD = newParameterArray[i][25];
                        var CLASSIFIED_SUB_REQUEST = newParameterArray[i][26];
                        var SUBSTITUTE_REQUEST_CERTIFICATED = newParameterArray[i][27];
                        var STIPENDS_FORM = newParameterArray[i][28];
                        var PERSONAL_SERVICE_AGREEMENT = newParameterArray[i][29];
                        var EMPLOYEE_HAND_BOOK = newParameterArray[i][30];
                        var PERSONNEL_ACTION_FORM = newParameterArray[i][31];
                        var userPermission = newParameterArray[i][32];
                        var csvDesignation = newParameterArray[i][33];
                        var timeRIsInitiator = newParameterArray[i][34];
                        var timeRIsApprover = newParameterArray[i][35];
                        var timeRIsPayroll = newParameterArray[i][36];
                        var timeRIsSuperadmin = newParameterArray[i][37];

                        //For Stipend data saved in userAdditionalSettings table
                        var stipendInitiator = newParameterArray[i][38];
                        var stipendApprover = newParameterArray[i][39];
                        var stipendPayroll = newParameterArray[i][40];

                        var csvEmployeeName = capitalizeFirstChar(csvLastName) + ', ' + csvFirstName.toUpperCase();

                        let strike = 0;

                        let existingEmployee = preSignupEmployeesListData.find(o => o.email === csvEmail);

                        console.log("OBJ", existingEmployee);

                        // let managerDetails = preSignupEmployeesListData.find(o => o.email === csvReportingManagerEmail);
                        let schoolDetails = allSchools.find(o => o.name.toUpperCase() === csvSchoolCode.toUpperCase());

                        if (!csvEmail || existingEmployee) {
                            strike = 1;
                            console.log("strike", csvEmail)
                        }

                        if (existingEmployee) { //&& userPermission === 1

                            console.log('existingEmployee', JSON.stringify(existingEmployee))

                            await DataStore.delete(PreSignupEmployeeApps, (c) => c.email.eq(existingEmployee.email)).then(async () => {
                                if (WEEKLY_ABSENCE_REPORT === 1) { await DataStore.save(new PreSignupEmployeeApps({ "appId": appIdData.WEEKLY_ABSENCE_REPORT, "email": existingEmployee.email })) }
                                if (WEEKLY_ABSENCE_REPORT_ADMIN === 1) { await DataStore.save(new PreSignupEmployeeApps({ "appId": appIdData.WEEKLY_ABSENCE_REPORT_ADMIN, "email": existingEmployee.email })) }
                                if (TIME_REPORT === 1) { await DataStore.save(new PreSignupEmployeeApps({ "appId": appIdData.TIME_REPORT, "email": existingEmployee.email })) }
                                if (SIX_PERIOD === 1) { await DataStore.save(new PreSignupEmployeeApps({ "appId": appIdData.SIX_PERIOD, "email": existingEmployee.email })) }
                                if (CLASSIFIED_SUB_REQUEST === 1) { await DataStore.save(new PreSignupEmployeeApps({ "appId": appIdData.CLASSIFIED_SUB_REQUEST, "email": existingEmployee.email })) }
                                if (SUBSTITUTE_REQUEST_CERTIFICATED === 1) { await DataStore.save(new PreSignupEmployeeApps({ "appId": appIdData.SUBSTITUTE_REQUEST_CERTIFICATED, "email": existingEmployee.email })) }
                                if (STIPENDS_FORM === 1) { await DataStore.save(new PreSignupEmployeeApps({ "appId": appIdData.STIPENDS_FORM, "email": existingEmployee.email })) }
                                if (PERSONAL_SERVICE_AGREEMENT === 1) { await DataStore.save(new PreSignupEmployeeApps({ "appId": appIdData.PERSONAL_SERVICE_AGREEMENT, "email": existingEmployee.email })) }
                                if (EMPLOYEE_HAND_BOOK === 1) { await DataStore.save(new PreSignupEmployeeApps({ "appId": appIdData.EMPLOYEE_HAND_BOOK, "email": existingEmployee.email })) }
                                if (PERSONNEL_ACTION_FORM === 1) { await DataStore.save(new PreSignupEmployeeApps({ "appId": appIdData.PERSONNEL_ACTION_FORM, "email": existingEmployee.email })) }
                            });

                        }

                        if (strike === 0) {
                            console.log('storing Data', csvEmail);

                            await DataStore.save(
                                new PreSignupEmployee({
                                    "email": csvEmail,
                                    "role": csvRole,
                                    "reportingMangerEmail": csvReportingManagerEmail,
                                    "employeeCode": csvEmployeeId.toString(),
                                    "employeeName": csvEmployeeName,
                                    "schoolCode": schoolDetails ? schoolDetails.id : '',
                                    "userType": csvUserType ? csvUserType : '',
                                    "isSixPeriodSAdmin": isSixPeriodSAdmin.toString(),
                                    "sixPeriodIsInitiator": sixPeriodIsInitiator.toString(),
                                    "sixPeriodIsApprover": sixPeriodIsApprover.toString(),
                                    "sixPeriodIsPayroll": sixPeriodIsPayroll.toString(),
                                    "certiSubRIsInitiator": certiSubRIsInitiator.toString(),
                                    "certiSubReIsApprover": certiSubReIsApprover.toString(),
                                    "certiSubReqIsPayroll": certiSubReqIsPayroll.toString(),
                                    "designation": csvDesignation ? csvDesignation : '',
                                    "isUser": userPermission === 1 ? 'true' : 'false',
                                    "timeRIsInitiator": timeRIsInitiator === '1' ? '1' : '0',
                                    "timeRIsApprover": timeRIsApprover === '1' ? '1' : '0',
                                    "timeRIsPayroll": timeRIsPayroll === '1' ? '1' : '0',
                                    "timeRIsSAdmin": timeRIsSuperadmin === '1' ? '1' : '0',
                                    "stipendInitiator": stipendInitiator === '1' ? '1' : '0',
                                    "stipendApprover": stipendApprover === '1' ? '1' : '0',
                                    "stipendPayroll": stipendPayroll === '1' ? '1' : '0',
                                })
                            ).then(async (res) => {

                                try {

                                    if (WEEKLY_ABSENCE_REPORT === 1) { await DataStore.save(new PreSignupEmployeeApps({ "appId": appIdData.WEEKLY_ABSENCE_REPORT, "email": csvEmail })) }
                                    if (WEEKLY_ABSENCE_REPORT_ADMIN === 1) { await DataStore.save(new PreSignupEmployeeApps({ "appId": appIdData.WEEKLY_ABSENCE_REPORT_ADMIN, "email": csvEmail })) }
                                    if (TIME_REPORT === 1) { await DataStore.save(new PreSignupEmployeeApps({ "appId": appIdData.TIME_REPORT, "email": csvEmail })) }
                                    if (SIX_PERIOD === 1) { await DataStore.save(new PreSignupEmployeeApps({ "appId": appIdData.SIX_PERIOD, "email": csvEmail })) }
                                    if (CLASSIFIED_SUB_REQUEST === 1) { await DataStore.save(new PreSignupEmployeeApps({ "appId": appIdData.CLASSIFIED_SUB_REQUEST, "email": csvEmail })) }
                                    if (SUBSTITUTE_REQUEST_CERTIFICATED === 1) { await DataStore.save(new PreSignupEmployeeApps({ "appId": appIdData.SUBSTITUTE_REQUEST_CERTIFICATED, "email": csvEmail })) }
                                    if (STIPENDS_FORM === 1) { await DataStore.save(new PreSignupEmployeeApps({ "appId": appIdData.STIPENDS_FORM, "email": csvEmail })) }
                                    if (PERSONAL_SERVICE_AGREEMENT === 1) { await DataStore.save(new PreSignupEmployeeApps({ "appId": appIdData.PERSONAL_SERVICE_AGREEMENT, "email": csvEmail })) }
                                    if (EMPLOYEE_HAND_BOOK === 1) { await DataStore.save(new PreSignupEmployeeApps({ "appId": appIdData.EMPLOYEE_HAND_BOOK, "email": csvEmail })) }
                                    if (PERSONNEL_ACTION_FORM === 1) { await DataStore.save(new PreSignupEmployeeApps({ "appId": appIdData.PERSONNEL_ACTION_FORM, "email": csvEmail })) }

                                    let original = await DataStore.query(PreSignupEmployee, res.id);
                                    /*  var updatedUserDetails = await DataStore.save(
                                         Employee.copyOf(original, (updated) => {
                                             updated.user_Id = userCreated.userSub;
                                         })
                                     ); */
                                    preSignupEmployeesListData.push(original)

                                }
                                catch (error) {
                                    console.log("Getting error", error)
                                }


                                   const params2 = {
                                        UserPoolId: awsmobile.aws_user_pools_id,
                                        Username: csvEmail,
                                        Password: 'Gusd@2023',
                                        Permanent: true,
                                    };

                                    const cognito = new AWS.CognitoIdentityServiceProvider();
                                    //User Confirmation 
                                    cognito.adminSetUserPassword(params2, (err, data) => {
                                        if (err) {
                                            console.log('Error confirming user:', err);
                                        } else {
                                            console.log('User confirmed successfully:', data);
                                        }
                                    });

                            });

                        }

                    }

                }
            });
        }
        setChecked(true)
        setPreSignupChecked(false)
        setImportFileObj("")
        setVisibleImport(false)
        toast.success("Imported Successfully");
    }

    async function saveSignupEmployeeLogin() {

        const appIdData = Object.keys(Apps)

        if (importLoginFileObj === '') {
            toast.error('Please select file.');
            return;
        }

        if (importLoginFileObj.size === 0) {
            toast.error('Do not select empty file.');
        } else {
            ExcelRenderer(importLoginFileObj, async (err, resp) => {
                if (err) {
                    console.log(err);
                }
                else {
                    console.log('importLoginFileObjresp --->', resp);
                    var parameterData = resp.rows
                    var newParameterArray = parameterData.slice(1);

                    for (let i = 0; i < newParameterArray.length; i++) {

                        var csvFirstName = newParameterArray[i][1];
                        var csvEmail = newParameterArray[i][2];
                        var csvPassword = newParameterArray[i][3];


                        let strike = 0;

                        if (strike === 0) {
                            console.log('storing Data', csvEmail);

                            await API.graphql(
                                graphqlOperation(mutations.createLoginEmail, {
                                    input: {
                                        firstName: csvFirstName,
                                        email: csvEmail,
                                        password: csvPassword.toString(),
                                    }
                                })
                            ).then((res) => {
                                console.log(res)
                            });

                            console.log(i, csvEmail)

                        }

                    }

                }
            });
        }

        setImportLoginFileObj("")
        setVisibleImportLogin(false)
        toast.success("Imported Successfully");
    }


    const searchEmployee = (searchedText) => {
        if (searchedText.length > 1) {
            let data = [...filterEmployeeList]
            let filteredData = data.filter(e =>
                e.employee_name.toLowerCase().includes(searchedText.toLowerCase()) ||
                // e.employee_code.toLowerCase().includes(searchedText.toLowerCase()) ||
                e.email.toLowerCase().includes(searchedText.toLowerCase())
            )
            SetEmployeeList(filteredData)
        } else {
            let data = [...filterEmployeeList]
            SetEmployeeList(data)
        }
    }

    async function onLoad() {
        try {
           await Auth.currentSession();
           if (!ValidateAdminRole()) { userHasAuthenticated(false); }
        } catch (e) {
           console.log("error-->", e)
           userHasAuthenticated(false);
        }
     }

    useEffect(() => {
        onLoad();
        BindList();
    }, []);


    return isAuthenticated ? (
        <div>
            <Layout pageTitle="Dashboard">

                <div className="">
                    <div className="dashboard-main-wrapper pr-4 mt-3">
                        <div className='wrapper-custom-views mt-8'>

                            <div className="flex flex-1 flex-wrap pt-5 px-0 top-action-wrapper">
                                <div className="md:flex xs:w-full sm:w-full md:w-auto flex-row align-center">
                                    <div className="md:flex block md:col-span-2 mb-4">
                                    </div>
                                    <div className="md:flex block">
                                        <h2 className="page-title px-5">Employees</h2>
                                    </div>
                                </div>

                                <div className="md:flex flex-1 px-5 flex-row xs:w-full sm:w-full md:w-auto align-center justify-end md:ml-auto gap-3 right-side">
                                    <div className="md:flex block gap-3">
                                        <Link to="/masters" className=" py-2 px-5 bg-white text-[#344054] transition ease-in duration-200 text-[14px] text-center font-medium  shadow-md focus:outline-none leading-6  justify-center rounded-lg border border-[#D0D5DD] rounded-md dark:bg-[#333231] dark:border-[#333231]  dark:text-[#FFFFFF]">Back</Link>
                                        <Link to="/admin/setting/masters/createemployee"  className=" py-2 px-6 bg-btn-blue text-[#fff] transition ease-in duration-200 text-[14px] text-center font-medium  shadow-md focus:outline-none leading-6 bg-[#113699]  justify-center rounded-lg border border-[#D0D5DD] rounded-md">Create</Link>
                                        <Link
                                            to=""
                                            onClick={() => {
                                                setVisibleImport(true);
                                                setChecked(true)
                                                setPreSignupChecked(false)
                                            }}
                                            className="flex py-2 px-5 bg-btn-blue hover:bg-blue-0 focus:ring-blue-500 focus:ring-offset-blue-200 text-white transition ease-in duration-200 text-[14px] text-center font-medium drop-shadow shadow-md focus:outline-none focus:ring-1 focus:ring-offset-1 leading-6  justify-center rounded-md border-1 border-[#1570EF] bg-[#113699]"
                                        >
                                            Import
                                        </Link>

                                        <Link
                                            to=""
                                            onClick={() => setVisibleImportLogin(true)}
                                            className="flex py-2 px-5 bg-btn-blue hover:bg-blue-0 focus:ring-blue-500 focus:ring-offset-blue-200 text-white transition ease-in duration-200 text-[14px] text-center font-medium drop-shadow shadow-md focus:outline-none focus:ring-1 focus:ring-offset-1 leading-6  justify-center rounded-md border-1 border-[#1570EF] bg-[#113699]"
                                        >
                                            Import Login
                                        </Link>

                                    </div>
                                </div>
                            </div>

                            <div>
                                <input
                                    type="text"
                                    onChange={(e) => {
                                        searchEmployee(e.target.value);
                                    }}
                                    className="text-[15px] rounded-lg  flex-1  border border-[#D0D5DD] w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-500 shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-500 mt-4 placeholder:text-[#667085] dark:bg-[#333231] dark:border-[#333231]"
                                    placeholder="Search"
                                />
                            </div>
                            <div>
                                <div className={"block w-full pt-5"}>
                                    {
                                        <DataTable
                                            columns={parentDataTableColumns}
                                            data={employeeList}
                                            customStyles={DataTableCustomStyles}
                                            pagination
                                            highlightOnHover
                                        />
                                    }
                                </div>
                            </div>
                        </div>

                        <Dialog className="relative reports-popup" visible={visibleImport} position="right" style={{ width: '50vw' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }} onHide={() => setVisibleImport(false)} draggable={false} resizable={false}>
                            <div className="">
                                <div className="bg-[#F5F6F7] h-screen">
                                    <div className="p-5">
                                        <Link to='' onClick={() => setVisibleImport(false)} className="py-3">
                                            <Image
                                                src={sidebar} alt="user" width="24" height="24" /></Link>
                                        <div className="mb-3 text-[#113699] mt-2 font-semibold">Import Employees</div>

                                        <div className="space-y-2 print:space-y-0">
                                            <div className='flex items-center gap-2'>
                                                <Checkbox onChange={e => changeChecked(e.checked, 'Employee')} checked={checked} />
                                                <div>Employee</div>
                                            </div>
                                            <div className='flex items-center gap-2'>
                                                <Checkbox onChange={e => changeChecked(e.checked, 'Pre-Signup')} checked={preSignupChecked} />
                                                <div>Pre Sign-up</div>
                                            </div>
                                        </div>

                                        {/* <div className="text-[#344054] text-xs lg:text-[0.625vw] font-medium">Pre sign-up Employees</div> */}

                                        <div className="py-3 bg-white px-5 rounded-[8px] mt-3">
                                            {checked ?
                                                <input id="fileProfilePic" type="file"
                                                    onChange={changeFileSelected} /> :
                                                <input id="fileProfilePic" type="file"
                                                    onChange={changeImportFile}
                                                />}
                                        </div>

                                    </div>
                                    <div className='p-2 float-right'>
                                        <a href="#" onClick={(e) => downloadDocument('public/importFile/importPreSignUpEmployee.csv')}
                                            className="text-sm text-[#0000FF] px-4 py-2 dark:text-white" rel="noreferrer">
                                            Download Template </a>
                                    </div>
                                    <div className='p-2 mt-4 ml-4'>

                                    </div>
                                    <div className="absolute right-5 bottom-5 flex justify-end gap-2">
                                        <Link to='#' className="bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#344054] flex items-center text-xs py-[6px] px-[10px] rounded-[8px] justify-center w-20" onClick={() => setVisibleImport(false)}>Cancel</Link>

                                        {checked ?
                                            <Link to='' className="w-32 text-center flex items-center tableBtn blue radius8" onClick={() => previewEmployee()}>Import</Link> : <Link to='' className="w-32 text-center flex items-center tableBtn blue radius8" onClick={() => saveSignupEmployee()}>Import</Link>
                                        }

                                    </div>
                                </div>
                            </div>
                        </Dialog>


                        <Dialog className="relative reports-popup" visible={visibleImportLogin} position="right" style={{ width: '50vw' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }} onHide={() => setVisibleImportLogin(false)} draggable={false} resizable={false}>
                            <div className="">
                                <div className="bg-[#F5F6F7] h-screen">
                                    <div className="p-5">
                                        <Link to='' onClick={() => setVisibleImportLogin(false)} className="py-3">
                                            <Image
                                                src={sidebar} alt="user" width="24" height="24" /></Link>
                                        <div className="mb-3 text-[#113699] mt-2 font-semibold">Import Login</div>

                                        {/* <div className="text-[#344054] text-xs lg:text-[0.625vw] font-medium">Pre sign-up Employees</div> */}

                                        <div className="py-3 bg-white px-5 rounded-[8px] mt-3">
                                            <input id="fileProfilePic" type="file"
                                                onChange={changeImportLoginFile}
                                            />
                                        </div>

                                    </div>

                                    <div className="absolute right-5 bottom-5 flex justify-end gap-2">
                                        <Link to='#' className="bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#344054] flex items-center text-xs py-[6px] px-[10px] rounded-[8px] justify-center w-20" onClick={() => setVisibleImportLogin(false)}>Cancel</Link>

                                        <Link to='' className="w-32 text-center flex items-center tableBtn blue radius8" onClick={() => saveSignupEmployeeLogin()}>Import Login</Link>


                                    </div>
                                </div>
                            </div>
                        </Dialog>

                    </div>
                </div>
            </Layout>
        </div>
    ) : (
        <Login sessionExpired={1} />
    )
}